export default "__VITE_ASSET__DhpyYRlO__"